import { authApiService } from '@/api/authApiService';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { ApiResponseType, ListResponseType } from '@/types/sharedTypes';

type InternalOrganizationMasterAdminsResponseType = {
  id: string;
  email: string;
};

export const getInternalOrganizationActiveMasterAdminsApi = async (
  params?: ApiParams
): Promise<ApiResponseType<ListResponseType<InternalOrganizationMasterAdminsResponseType>>> => {
  const uri = '/organization/internal/users/active-master-admins/';

  return authApiService.GET(uri, params);
};
